import api from '../../api/axiosInstance';

// Search existing users (uses existing /search/users returns signed URLs)
export async function searchUsersPublic(query, { signal } = {}) {
  if (!query?.trim()) return [];
  const { data } = await api.get('/search/users', { params: { query }, signal });
  // Map to common shape expected by selectors. Provide a sensible default avatar
  // when the user has no profile picture. The app uses `/assets/images/default_profile.png`
  // in multiple places so reuse that path here.
  return (data.users || []).map((u) => ({
    id: u.user_id,
    label: u.username,
    avatar: u.profilePictureUrl || '/assets/images/default_profile.png',
  }));
}

// Countries (admin + pending). Query param: q
export async function searchCountries(query, { signal } = {}) {
  if (!query?.trim()) return [];
  const { data } = await api.get('/search/countries', { params: { q: query }, signal });
  return (data.countries || []).map((c) => ({
    id: c.id,
    label: c.name,
    source: c.source,
    type: 'country',
  }));
}

// Cities & states (admin + pending). Accept optional array of selected country IDs.
export async function searchCities(query, countryIds = [], { signal } = {}) {
  if (!query?.trim()) return [];
  const { data } = await api.get('/search/cities', {
    params: { q: query, countryIds: countryIds.join(',') },
    signal,
  });
  return (data.localities || []).map((l) => ({
    id: l.id,
    label: l.name,
    source: l.source,
    type: l.type, // city or state
  }));
}

// Places (canonical + pending) filtered by selected countries & cities
export async function searchPlaces(query, { countryIds = [], cityIds = [], signal } = {}) {
  if (!query?.trim()) return [];
  const { data } = await api.get('/search/places', {
    params: {
      q: query,
      countryIds: countryIds.join(','),
      cityIds: cityIds.join(','),
    },
    signal,
  });
  return (data.places || []).map((p) => ({
    id: p.id,
    label: p.name,
    source: p.source,
  }));
}
